/**
 * Locale message tables for Genesis/Home narrative keys (complete sentences).
 */

import type { GenesisHomeNarrativeTranslationKeyV0 } from './translation-keys';

export type NarrativeLocaleTableV0 = Record<GenesisHomeNarrativeTranslationKeyV0, string>;

export const NARRATIVE_MESSAGES_KO_V0: NarrativeLocaleTableV0 = {
  'home.hero.category': '회사의 모든 일을 한곳에서 이어주는 운영 시스템',
  'home.hero.promise':
    '주문, 구매, 생산, 승인처럼 회사에서 생긴 일이 담당자의 할 일이 되고, 처리 결과와 증빙이 기록으로 남습니다.',
  'home.hero.differentiator':
    'ERP가 끝난 일을 기록한다면, Inflomatrix는 다음에 해야 할 일을 만들고 처리 결과까지 회사의 기록으로 연결합니다.',
  'home.hero.ctaPrimary': '우리 조직 시작하기',
  'home.hero.ctaSecondary': '실제 흐름 보기',
  'home.hero.inviteHint': '초대 코드가 있는 조직만 시작할 수 있습니다 · 온보딩에서 확인합니다.',
  'home.breakPoints.eyebrow': '현장에서 반복되는 일',
  'home.breakPoints.title': "'처리됐나?'를 사람에게 다시 묻고 있다면, 이 페이지가 맞습니다",
  'home.breakPoints.intro':
    '카카오로 주문받고, 엑셀에 적고, 완료되면 따로 알리고 — 도구를 늘릴수록 연결은 더 끊깁니다.',
  'home.oneFlow.eyebrow': '하나로 이어지는 흐름',
  'home.oneFlow.title': '사이트에 주문이 들어오면, 담당자 업무함에 할 일이 뜹니다',
  'home.oneFlow.intro':
    '손님을 상대하는 사이트와 내부 처리를 함께 운영하는 조직을 위해, 주문이 들어오는 순간 담당자 업무함에 할 일이 생기는 흐름을 초대제로 확인할 수 있습니다.',
  'home.proof.eyebrow': '증거',
  'home.proof.title': '손님 화면과 운영 화면이 하나의 흐름으로 연결됩니다',
  'home.proof.intro':
    '아래 스크린샷은 demo.staging.inflomatrix.app에서 신규 손님 주문 한 건으로 캡처했습니다. 상태는 접수됨 — 처리 결과 스크린샷은 별도 캡처 전까지 주장하지 않습니다.',
  'home.proof.scope':
    '방문자가 지금 보는 것은 초대제 파일럿으로 확인한 주문 → 업무함 → 접수 확인, 이 한 구간입니다. 모든 업종·모든 신청 양식에 동일하다고 말하지 않습니다.',
  'home.moreThanOrders.eyebrow': '주문, 그 이상',
  'home.moreThanOrders.title':
    '쇼핑몰은 주문을 받습니다. Inflomatrix는 주문을 처리하고 기록합니다.',
  'home.moreThanOrders.body':
    'ERP는 끝난 일을 기록합니다. Inflomatrix는 다음 일을 만들어 담당자에게 연결하고, 처리 결과를 다시 회사의 기록으로 남깁니다.',
  'home.threeChanges.eyebrow': '달라지는 세 가지',
  'home.threeChanges.title': '주문이 기록으로 이어지는 방식',
  'home.toolComparison.eyebrow': '비교',
  'home.toolComparison.title': '주문을 받는 것과, 주문을 처리하고 기록하는 것은 다릅니다',
  'home.toolComparison.footnote':
    '초대제 파일럿 범위: 상품 상세 → 손님 주문 → 담당자 업무함 경로. 모든 양식·모든 업종에 동일하다고 말하지 않습니다.',
  'home.sharedRecord.eyebrow': '하나의 기록을 공유',
  'home.sharedRecord.title': '사이트에서 들어온 일이 내부 업무함으로 이어집니다',
  'home.sharedRecord.intro':
    '조직 하나를 만들면, 손님이 보는 사이트와 내부 처리 업무함이 같은 기록 위에서 연결됩니다. 사이트가 필요 없는 조직(예: 내부-only 팀)은 업무함만으로도 시작할 수 있습니다.',
  'home.startNow.eyebrow': '지금 시작할 수 있는 일',
  'home.startNow.title': '지금 무엇부터 시작할 수 있나요?',
  'home.startNow.subtitle':
    '우리는 미래를 말하지만, 지금 가능한 것과 아직 아닌 것을 섞어 말하지 않습니다.',
  'home.startNow.now.label': '지금 사용할 수 있어요',
  'home.startNow.prepare.label': '회사에 맞게 함께 준비해요',
  'home.startNow.notYet.label': '아직은 아니에요',
  'home.ahead.eyebrow': '앞으로의 방향',
  'home.ahead.title': '루프를 먼저 증명하고, 그 위에 더 깊은 운영 지능을 쌓습니다',
  'home.ahead.body':
    '지금 증명한 것은 주문이 담당자의 할 일이 되고, 처리 결과가 기록으로 남는 흐름입니다. 앞으로는 반복되는 일을 기계가 먼저 알아채고 사람에게 제안하는 방향으로, 그리고 언젠가 사람과 기계가 같은 기록 위에서 함께 일하는 방향으로 나아갑니다. 지금 이 페이지가 보여주는 것은 그 시작점입니다.',
  'home.finalCta.title': '지금 우리 조직을 시작하세요',
  'home.finalCta.body': '조직 생성은 약 2분이면 됩니다. 상세 설정은 나중에 이어서 할 수 있습니다.',
  'home.finalCta.ctaPrimary': '우리 조직 시작하기',
  'home.finalCta.ctaSecondary': '파일럿 초대 요청하기',
  'capabilities.connectOperations.label': '운영 연결',
  'capabilities.connectOperations.problem': '주문·업무·처리가 도구마다 끊깁니다.',
  'capabilities.connectOperations.prepares':
    '사이트·업무함·운영 모듈을 한 흐름으로 연결할 준비를 합니다.',
  'capabilities.connectOperations.example': '손님 주문이 담당자 업무함으로 이어지는 흐름',
  'capabilities.trustNumbers.label': '숫자 신뢰',
  'capabilities.trustNumbers.problem': '장부와 현장 숫자가 서로 맞지 않습니다.',
  'capabilities.trustNumbers.prepares': '회계·수량 기록을 같은 운영 흐름 위에 올립니다.',
  'capabilities.trustNumbers.example': '입고·재고·회계가 같은 기록으로 맞춰지는 흐름',
  'capabilities.authorityEvidence.label': '권한과 증빙',
  'capabilities.authorityEvidence.problem': '누가 왜 실행했는지 나중에 설명하기 어렵습니다.',
  'capabilities.authorityEvidence.prepares': '요청·검토·승인·처리가 기록으로 남도록 준비합니다.',
  'capabilities.authorityEvidence.example': '승인 기록과 처리 증빙이 함께 남는 흐름',
  'capabilities.physicalContext.label': '현장 연결',
  'capabilities.physicalContext.problem': '현장 위치·물건이 시스템과 연결되지 않습니다.',
  'capabilities.physicalContext.prepares': '현장 스캔으로 물건과 장소를 연결할 준비를 합니다.',
  'capabilities.physicalContext.example': '창고의 물건과 장소를 스캔으로 연결하는 흐름',
  'capabilities.temporalContext.label': '일정 연결',
  'capabilities.temporalContext.problem': '언제 무엇을 할지 계획이 시스템에 남지 않습니다.',
  'capabilities.temporalContext.prepares': '반복 일정과 정기 업무를 연결할 준비를 합니다.',
  'capabilities.temporalContext.example': '정기 업무가 일정에 맞춰 할 일로 생기는 흐름',
  'capabilities.governedAi.label': '통제된 AI',
  'capabilities.governedAi.problem': 'AI 제안이 확인·증빙 없이 바로 실행되면 위험합니다.',
  'capabilities.governedAi.prepares':
    '사람이 확인한 범위에서 AI가 분석·제안하고 실행까지 이어지게 합니다.',
  'capabilities.governedAi.example': '사람이 확인한 뒤 다음 행동을 제안하는 AI 흐름',
  'capabilities.humanoidVision.label': '휴머노이드 비전',
  'capabilities.humanoidVision.problem':
    '미래 물리 행위자를 같은 운영 언어에 올릴 준비가 필요합니다.',
  'capabilities.humanoidVision.prepares':
    '지금은 비전·계획으로만 서술합니다. 실세계 실행을 주장하지 않습니다.',
  'capabilities.humanoidVision.example': '같은 업무 흐름을 사람이 먼저 쓰는 단계',
  'claim.qualifier.proven': '검증됨',
  'claim.qualifier.preview': '미리보기',
  'claim.qualifier.planned': '계획',
  'claim.qualifier.vision': '비전',
  'maturity.current': '현재',
  'maturity.nearTerm': '가까운 계획',
  'maturity.longTerm': '장기 비전',
  'genesis.stage1.title': '어떤 조직인지 먼저 이해할게요',
  'genesis.stage1.subtitle':
    '규모와 운영 형태를 고르면 나머지를 맞춰 드립니다. 입력한 정보로 사이트·업무함 초안을 자동으로 준비합니다.',
  'genesis.stage1.cta.primary': '계속',
  'genesis.stage1.cta.secondary': '잘 모르겠어요 — 추천 받기',
  'genesis.stage1.trust': '고른 내용은 언제든 바꿀 수 있고, 지금 선택이 최종이 아닙니다.',
  'genesis.stage2.title': '이미 있는 자료를 올리면 직접 입력을 줄여 드립니다',
  'genesis.stage2.subtitle':
    '회사소개서·기존 사이트 주소·상품 목록 무엇이든 좋아요. 완벽하지 않아도 괜찮습니다 — 있는 만큼만 주세요.',
  'genesis.stage2.trust':
    '올린 자료는 초안 작성에만 사용하고, 확정 전에는 아무것도 공개되지 않습니다.',
  'genesis.stage2.claimBoundary': '자동 추출은 초안입니다 — 다음 단계에서 직접 확인합니다.',
  'genesis.stage2.source.url': '기존 사이트 주소',
  'genesis.stage2.source.file': '회사소개서·문서 (파일명 메모)',
  'genesis.stage2.source.catalog': '상품·서비스 목록 힌트',
  'genesis.stage2.source.optional': '모두 선택 사항입니다. 비워 두어도 계속할 수 있습니다.',
  'genesis.stage3.title': '자료에서 이런 정보를 찾았어요. 맞으면 확인, 아니면 고쳐 주세요',
  'genesis.stage3.trust':
    'AI가 채운 값은 회색 배지로 표시됩니다. 당신이 확인하기 전까지는 추정입니다.',
  'genesis.stage3.claimBoundary':
    '자동 채움은 통제된 assistive 범위입니다. 무제한 자율이 아닙니다.',
  'genesis.stage3.badge.ai': 'AI 추천 · 출처: {source}',
  'genesis.stage3.badge.confirmed': '확인됨',
  'genesis.stage3.empty': '아직 확인할 추출 항목이 없습니다. 입력을 이어가거나 자료를 추가하세요.',
  'genesis.stage4.title': '이 조직에 맞는 운영 능력을 추천합니다',
  'genesis.stage4.subtitle':
    '추천 능력은 A–F만 제안합니다. 맞지 않으면 나중에 바꾸거나 세부 내용을 확인할 수 있습니다.',
  'genesis.stage4.why': '추천 근거: 입력한 규모·운영 형태',
  'genesis.stage4.cta.accept': '추천 수락',
  'genesis.stage4.cta.later': '나중에',
  'genesis.stage4.cta.details': '세부 보기',
  'genesis.stage4.minimumFloor': '운영 연결과 권한·증빙은 최소 기본으로 포함됩니다.',
  'genesis.stage5.title': '지금 시작해도 됩니다',
  'genesis.stage5.subtitle':
    '아래 항목은 비어 있지만 정보 부족이 설정 실패를 뜻하지 않습니다. 분류를 확인하세요.',
  'genesis.stage5.trust': '비어 있어도 조직 생성은 됩니다. 공개는 당신이 누를 때만 이뤄집니다.',
  'genesis.stage5.insufficientInfo': '정보가 부족해도 구성 실패가 아닙니다.',
  'genesis.stage5.gap.mustResolve': '첫 업무를 막으므로 지금 해결이 필요합니다.',
  'genesis.stage5.gap.useDefault': '추천 기본값을 쓰면 지금 진행할 수 있습니다.',
  'genesis.stage5.gap.configureLater': '나중에 Business에서 설정할 수 있습니다.',
  'genesis.stage5.gap.notNeeded': '첫 업무에는 필요하지 않습니다.',
  'genesis.stage5.gap.insufficientInfo': '정보 부족은 설정 실패가 아닙니다.',
  'genesis.stage6.title': '이 내용으로 조직을 만듭니다. 만들기 전에 한 번 확인하세요',
  'genesis.stage6.trust': '확인을 누르기 전까지 아무것도 생성되지 않습니다.',
  'genesis.stage6.irreversible': '조직 주소({org}.inflomatrix.app)는 확정됩니다.',
  'genesis.stage6.cta.primary': '조직 만들기',
  'genesis.stage6.cta.secondary': '이전 단계 수정',
  'genesis.stage6.item.workspace': '워크스페이스·조직 주소',
  'genesis.stage6.item.flows': '운영 흐름(Flow)',
  'genesis.stage6.item.objects': '업무 대상(Object)',
  'genesis.stage6.item.authority': '권한·승인(Authority)',
  'genesis.stage6.item.evidence': '증빙(Evidence)',
  'genesis.stage6.item.aiScope': 'AI 범위(통제된 assist)',
  'genesis.stage6.item.excluded': '이번 생성에서 제외되는 항목',
  'genesis.stage7.title': '회사 운영 구조를 준비하는 중',
  'genesis.stage7.subtitle': '기술 단계가 아니라 업무 가치 단위로 진행 상황을 보여 드립니다.',
  'genesis.stage7.trust': '실패한 단계가 있으면 여기서 바로 알려 드립니다.',
  'genesis.stage7.step.workspace': '워크스페이스 준비',
  'genesis.stage7.step.teamPermissions': '팀·권한 준비',
  'genesis.stage7.step.workflows': '운영 흐름 준비',
  'genesis.stage7.step.docsEvidence': '문서·증빙 준비',
  'genesis.stage7.step.firstWork': '첫 업무 준비',
  'genesis.stage7.step.verify': '완료 확인',
  'genesis.stage8.title': '첫 업무를 시작할 준비가 됐습니다',
  'genesis.stage8.subtitle':
    '추천 첫 업무, 대상·출처, 역할, 증빙, 시작 CTA를 확인하세요. 나중 항목은 따로 표시됩니다.',
  'genesis.stage8.finishLine': 'FIRST_OPERATION_READY',
  'genesis.stage8.cta.primary': '첫 업무 시작',
  'genesis.stage8.cta.secondary': '나중에 설정할 항목 보기',
  'genesis.stage8.laterItems': '공개 사이트·세부 권한·추가 모듈은 나중에 설정할 수 있습니다.',
  'genesis.stage8.humanoidSecondary':
    '미래의 물리 행위자(휴머노이드) 서사는 보조 안내이며, 지금 첫 업무의 조건이 아닙니다.',
  'genesis.stage8.firstOp.procurementReceiving.why': '입고·검수 흐름이 입력 신호와 잘 맞습니다.',
  'genesis.stage8.firstOp.procurementReceiving.objects': '구매 주문·입고 대상 품목',
  'genesis.stage8.firstOp.procurementReceiving.role': '입고 담당자',
  'genesis.stage8.firstOp.procurementReceiving.evidence': '수량·검수 증빙',
  'genesis.stage8.firstOp.catalogOrder.why': '카탈로그 주문 루프가 입력 신호와 잘 맞습니다.',
  'genesis.stage8.firstOp.catalogOrder.objects': '상품·게스트 주문',
  'genesis.stage8.firstOp.catalogOrder.role': '주문 처리 담당자',
  'genesis.stage8.firstOp.catalogOrder.evidence': '주문 접수 영수증',
  'genesis.stage8.firstOp.general.why': '조직 기본 정보를 바탕으로 일반 첫 업무를 준비합니다.',
  'genesis.stage8.firstOp.general.objects': '조직·업무함 기본 항목',
  'genesis.stage8.firstOp.general.role': '조직 관리자',
  'genesis.stage8.firstOp.general.evidence': '구성 완료 기록',
  'genesis.stage8.firstOp.procurementReceiving.label': '입고·검수 업무',
  'genesis.stage8.firstOp.catalogOrder.label': '주문 처리 업무',
  'genesis.stage8.firstOp.general.label': '조직 첫 업무 준비',
  'genesis.adaptive.dontKnow': '잘 모르겠어요 — 추천 받기',
  'gap.class.MUST_RESOLVE_NOW': '지금 해결 필요',
  'gap.class.USE_RECOMMENDED_DEFAULT': '추천 기본값 사용',
  'gap.class.CONFIGURE_LATER': '나중에 설정',
  'gap.class.NOT_NEEDED_FOR_FIRST_OPERATION': '첫 업무에 불필요',
};
